import * as _ from 'lodash'
import { Section, ElementProperties, Variable, if as _if, not, all, Div } from 'alkali'
import SummaryTab from 'components/extract/SummaryTab'
import { ExtractionHistory } from 'components/extract/ExtractionHistory'
import ExtractionModel from 'components/extract/model/ExtractionModel'
import { CollapsibleSection } from 'components/generic/CollapsibleSection'
import Tabbed from 'components/generic/Tabbed'
import MetadataTab from 'components/extract/MetadataTab'

export interface DetailsColOpts extends ElementProperties<DetailsCol> {
	extractionModel: ExtractionModel,
	manage?: boolean
	debug?: boolean
}

/**
 * Column with only read-only study, summary and extraction history tabs.
 */
export default class DetailsCol extends Section('.extract-col.vertical-extraction-content') {
	created(props: DetailsColOpts) {
		const { extractionModel, debug, manage } = props
		const hasExtractions = extractionModel.study.extractions?.length
		const studyTab = new MetadataTab({ extractionModel, editStudy: !manage })
		const studyTabValid = all(studyTab.models.map(m => m.isValid), _.every)
		props.content = [
			new Tabbed({
				activeIndex: new Variable(1),
				leading: Div('.leading')
			}, [{
				label: 'Study',
				content: studyTab,
				config: {
					title: _if(not(studyTabValid), ['Errors exist on this tab']),
					classes: {
						invalid: not(studyTabValid)
					}
				}
			}, {
				label: 'Summary',
				content: [
					CollapsibleSection('.summary', {
						toggleable: false,
						header: 'Summary',
						body: new SummaryTab({ study: extractionModel.study }),
					}),
					hasExtractions ? CollapsibleSection('.extraction-history', {
						open: false,
						header: 'Extraction History',
						body: new ExtractionHistory({ extractionModel, readonly: true, debug })
					}) : undefined
				]
			}])
		]
	}
}